import { render, staticRenderFns } from "./ObligorPanel.vue?vue&type=template&id=9b3086d8"
import script from "./ObligorPanel.vue?vue&type=script&lang=js"
export * from "./ObligorPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports